module.exports = {
    lite2024CommonName: `Lite`,
    professional2024CommonName: `Professional`,
    expert2024CommonName: `Expert/Studio`,
    ultimate2025CommonName: `Ultimate`,
};
